<template>
    <div>
        <div ref="course-info-window" class="info-window hidden">
            <course-card v-if="updateCard"
                         @enroll="enroll"
                         :course="course"></course-card>
        </div>
        <div ref="mapContainer" style="height: 80vh"></div>
    </div>
</template>

<script>
import CourseCard from '@/components/CourseCard';

export default {
    name: "CoursesMap",
    props: {
        courses: {
            type: Array
        }
    },
    components: {
        CourseCard
    },
    data() {
        return {
            course: {},
            markers: [],
            updateCard: false,
            buildingMap: false
        };
    },
    mounted() {
        if (!this.buildingMap) {
            this.buildingMap = true;
            this._initMap();
            this.buildingMap = false;
        }

    },
    watch: {
        courses() {
            if (!this.buildingMap) {
                this.buildingMap = true;
                this._initMap();
                this.buildingMap = false;
            }
        }
    },
    methods: {
        enroll(id) {
            this.$emit('enroll', id);
        },
        _initMap() {
            const map = new google.maps.Map(this.$refs["mapContainer"], {
                zoom: 17,
                center: {
                    lat: 60.721188,
                    lng: -135.056839
                }
            });
            const bounds = new google.maps.LatLngBounds();
            this.markers = [];
            let fitBounds = false;

            this.courses.forEach((course) => {
                //First location
                if (course.locations.length) {
                    let location = course.locations[0];
                    fitBounds = true;
                    let locationLatLng = new google.maps.LatLng({lat: location.lat, lng: location.lon});

                    let marker = new google.maps.Marker({
                        position: locationLatLng,
                        map: map,
                        title: course.name,
                        course: course
                    });

                    this.markers.push(marker);

                    bounds.extend(marker.position);

                    const infoWindow = new SnazzyInfoWindow({
                        marker: marker,
                        content: this.$refs["course-info-window"],
                        closeWhenOthersOpen: true,
                        showCloseButton: false,
                        callbacks: {
                            open: () => {
                                this.$refs["course-info-window"].classList.remove("hidden");
                            },
                            beforeOpen: () => {
                                this.updateCard = false;
                                this.course = Object.assign({}, this.course, marker.course);
                                this.updateCard = true;
                            }
                        }
                    });
                }
            });

            if (fitBounds) {
                const markerCluster = new MarkerClusterer(map, this.markers, {
                    styles: [{
                        url: "/webroot/images/map-cluster.png",
                        textColor: "white",
                        width: 51,
                        height: 51
                    }]
                });
                map.fitBounds(bounds);
            }
        }
    }
}
</script>

<style scoped>

</style>
